module.exports = __webpack_public_path__ + "static/media/loc3_img8.1d26fdea.jpg";